// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-26UW0NYO","footer":"footer-3Y55Hh-n"};